import { accessRole } from "../../../../../helpers/access_role"
import { config } from "../../../../../helpers/config_global"
import React, { useState, Component, Fragment } from "react"
import { Redirect } from "react-router-dom"
import Shimmer from "react-shimmer-effect";

import { Tooltip, Row, Col, Table, Button } from "reactstrap"

import MKIDatatable from '../../../../../modules/mki-datatable/lib'
import { ConfirmAlert } from '../../../../../helpers/ui/alert'

import { cancelToken } from "../../../../../services/adapters/kepegawaian/skpService"

import DataTableBloc from '../Blocs/DataTableBloc'
import apiResponse from '../../../../../services/apiResponse'

import { AvForm, AvGroup, AvInput, AvField, AvCheckboxGroup, AvCheckbox } from "availity-reactstrap-validation"

import moment from "moment"

class TableActivePengukuranComponent extends Component {
    dataTableBloc = new DataTableBloc();

    queryParams = new URLSearchParams(window.location.search)

    source
    historyTable = 'historySKPRealisasiApprovalActive'
    defaultOrder = 'skp_id'
    defaultSize = 9999
    defaultSort = 'desc'
    configDatatable = {
        ...config('datatable'),
        sort: {
            column: this.defaultOrder,
            order: this.defaultSort
        }
    }

    constructor(props) {
        super(props)
        this.state = {
            tooltip: false,
            detailUuid: null,
            updateUuid: null,
            inactiveUuid: null,
            defaultSize: 10,
            rows: [],
            rowstt: [],
            totalRow: 0,
            totalNilaiSKP: 0,
            loadingTable: true,
            filter: sessionStorage.getItem(this.historyTable) ?
                JSON.parse(sessionStorage.getItem(this.historyTable)) :
                {
                    filter_value: "",
                    page_number: 1,
                    page_size: this.defaultSize,
                    sort_order: {
                        column: this.defaultOrder,
                        order: this.defaultSort
                    }
                }
        }
    }

    dateParse = (input) =>{
        let res = "";
        if (input != "" && input != null){
          res = moment(input).format('DD/MM/YYYY')
        }
        return res;
    }

    getEmployeeBirthDetail = (emp) => {
        let res = "";
        if (emp.employee_place_of_birth_city_uuid != null && emp.employee_place_of_birth_city_uuid != '') {
            res = `${emp.employee_place_of_birth_city_name}, ${this.dateParse(emp.employee_date_of_birth)}`;
        } else {
            res = `${emp.employee_place_of_birth_city_text}, ${this.dateParse(emp.employee_date_of_birth)}`;
        }
        return res;
    }

    toggleTooltip = () => this.setState({ tooltip: !this.state.tooltip });

    loadData = async () => {
        /* history Datatable */
        sessionStorage.setItem(this.historyTable, JSON.stringify(this.state.filter))

        let additionalFilter = this.props.additionalFilter;
        // let whereStatus = (this.props.atasan == 1 ? 5 : 6);
        let whereStatus = 7;

        /* kirim ke server */
        let offset = (this.state.filter.page_number-1)*this.state.filter.page_size
        if(this.state.defaultSize!==this.state.filter.page_size) {
            this.setState({
                defaultSize: this.state.filter.page_size
            })
            offset = 0
            this.configDatatable.page_number = 1
        }


        const query = {
            search: this.state.filter.filter_value,
            limit: this.state.filter.page_size,
            offset: offset,
            order: this.state.filter.sort_order.column,
            sort: this.state.filter.sort_order.order,
            status: whereStatus,
            ...additionalFilter
        }
        await this.dataTableBloc.fetchRowPengukuranTable(query, this.source.token)
    }
    loadDatatt = async () => {
        /* history Datatable */
        sessionStorage.setItem(this.historyTable, JSON.stringify(this.state.filter))

        let additionalFilter = this.props.additionalFilter;

        /* kirim ke server */
        let offset = (this.state.filter.page_number-1)*this.state.filter.page_size
        if(this.state.defaultSize!==this.state.filter.page_size) {
            this.setState({
                defaultSize: this.state.filter.page_size
            })
            offset = 0
            this.configDatatable.page_number = 1
        }
        const query = {
            search: this.state.filter.filter_value,
            limit: this.state.filter.page_size,
            offset: offset,
            order: this.state.filter.sort_order.column,
            sort: this.state.filter.sort_order.order,
            status: 1,
            ...additionalFilter
        }
        await this.dataTableBloc.fetctthRowTable(query, this.source.token)
    }

    setTokenAPI = () => {
        if (typeof this.source != typeof undefined) {
            this.source.cancel();
        }
        this.source = cancelToken()
        this.loadData()
        this.loadDatatt()
    }

    submitData = async () => {
        await this.dataTableBloc.fetchSendApprovePengukuran(this.state.dataForm)
    }

    handlerOnSubmit = (e, values) => {
        e.preventDefault()
        this.setState({
            dataForm: {
                // status: (this.props.atasan == 1 ? 6 : 7),
                statusbefore: 7,
                status: 8,
                atasan: this.props.atasan,
                perioduuid: this.queryParams.get('perioduuid'),
                ...values
            },
            confirm: true
        })
        console.log(values)
    }

    confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.submitData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }
    
    inactiveData = async () => {
        // await this.dataTableBloc.fetchDelete({ uuid: this.state.inactiveUuid })
    }

    componentDidMount() {
        this.setTokenAPI()
        this.dataTableBloc.rowpengukurantableChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.INITIAL:
                    this.setState({
                        loadingTable: false
                    })
                    break
                case apiResponse.LOADING:
                    this.setState({
                        loadingTable: true
                    })
                    break
                case apiResponse.COMPLETED:
                    const response = result.data.response
                    console.log(response.result[0].skp_status)
                    this.setState({
                        totalRow: response.total,
                        rows: response.result,
                        detail: response.employee,
                        loadingTable: false
                    })
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })

        this.dataTableBloc.rowtttableChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.INITIAL:
                    this.setState({
                        loadingTable: false
                    })
                    break
                case apiResponse.LOADING:
                    this.setState({
                        loadingTable: true
                    })
                    break
                case apiResponse.COMPLETED:
                    const response = result.data.response
                    this.setState({
                        totalRowtt: response.total,
                        rowstt: response.result,
                        loadingTable: false
                    })
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })

        this.dataTableBloc.sendApprovePengukuranChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true,
                    });
                    this.setTokenAPI()
                    // this.props.handleApproveSuccess()
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })

    }

    componentWillUnmount() {
        this.dataTableBloc.rowtargettableChannel.unsubscribe()
        this.dataTableBloc.sendApprovePengukuranChannel.unsubscribe()
    }

    render() {
        let totnilaiskp=0;
        let totnilaitt=(this.state.rowstt.length<1)?0:(this.state.rowstt.length==1)?1:(this.state.rowstt.length>1)?2:1
        return (
            <>
                <AvForm
                    className="needs-validation"
                    onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                >
                    <div className="table-responsive">
                        <Table className="table-bordered table-striped">
                            <thead style={{backgroundColor:'lavender'}}>
                                <tr className="text-center">
                                    <th rowSpan="2">No</th>
                                    <th rowSpan="2" style={{minWidth:"300px"}}>Kegiatan</th>
                                    <th colSpan="2">Angka Kredit</th>
                                    <th colSpan="2">Kuantitas</th>
                                    <th colSpan="2">Output</th>
                                    <th colSpan="2">Kualitas Mutu</th>
                                    <th colSpan="2">Waktu</th>
                                    <th colSpan="2">Satuan Waktu</th>
                                    <th colSpan="2">Biaya</th>
                                    {/* <th rowSpan="2">Catatan</th> */}
                                    <th rowSpan="2">Penghitungan</th>
                                    <th rowSpan="2">Capaian SKP</th>
                                </tr>
                                <tr>
                                    <th>Target</th>
                                    <th>Realisasi</th>
                                    <th>Target</th>
                                    <th>Realisasi</th>
                                    <th>Target</th>
                                    <th>Realisasi</th>
                                    <th>Target</th>
                                    <th>Realisasi</th>
                                    <th>Target</th>
                                    <th>Realisasi</th>
                                    <th>Target</th>
                                    <th>Realisasi</th>
                                    <th>Target</th>
                                    <th>Realisasi</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    this.state.totalRow > 0 ? 

                                        this.state.rows.map((data, index) => {
                                            totnilaiskp+= parseFloat(data.capaian_skp);
                                            return (
                                                <tr key={`skp_${index}`}>
                                                    <td align="center">{index+1}</td>
                                                    <td align="left">{data.skp_activity}</td>
                                                    <td align="right">{data.skp_target_angka_kredit}</td>
                                                    <td align="right">{data.skp_realisasi_angka_kredit}</td>
                                                    <td align="right">{data.skp_target_kuantitas}</td>
                                                    <td align="right">{data.skp_realisasi_kuantitas}</td>
                                                    <td align="left">{data.skp_target_output}</td>
                                                    <td align="left">{data.skp_realisasi_output}</td>
                                                    <td align="right">{data.skp_target_kualitas_mutu}</td>
                                                    <td align="right">{data.skp_realisasi_kualitas_mutu}</td>
                                                    <td align="right">{data.skp_target_waktu}</td>
                                                    <td align="right">{data.skp_realisasi_waktu}</td>
                                                    <td align="left">{data.skp_target_satuan_waktu}</td>
                                                    <td align="left">{data.skp_realisasi_satuan_waktu}</td>
                                                    <td align="right">{data.skp_target_biaya ?? '-'}</td>
                                                    <td align="right">{data.skp_realisasi_biaya ?? '-'}</td>
                                                    
                                                    <td align="right">
                                                        {data.perhitungan ?? '-'}
                                                        <td align="right">
                                                        <AvField
                                                            name={`skp_uuid[${index}]`}
                                                            type="hidden"
                                                            value={data.skp_uuid ?? ''}
                                                            />
                                                        <AvField
                                                            name={`perhitungan[${index}]`}
                                                            type="hidden"
                                                            value={data.perhitungan ?? ''}
                                                            />
                                                    </td>
                                                    </td>
                                                    <td align="right">
                                                        {data.capaian_skp ?? '-'}
                                                        <AvField
                                                            name={`capaian[${index}]`}
                                                            type="hidden"
                                                            value={data.capaian_skp ?? ''}
                                                        />
                                                    </td>
                                                </tr>
                                            );
                                        })

                                    : 
                                    <tr>
                                        <td colSpan="17" className="text-center">Tidak Ada Data Menunggu Approval</td>
                                    </tr>
                                }
                                <tr style={{backgroundColor:'lavender'}}>
                                    <th></th>
                                    <th colspan="17">Tugas Tambahan dan Kreativitas</th>
                                </tr>
                                {
                                    this.state.totalRow > 0 ? 

                                        this.state.rowstt.map((data, index) => {
                                            return (
                                                <tr key={`tt_${index}`}>
                                                    <td align="">{index+1}</td>
                                                    <td>{data.skp_activity}</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    {/* <td></td> */}
                                                    <td className="text-center">
                                                        {/* {(data.skp_note_realisasi_boss!='')?data.skp_note_realisasi_boss:'-'} */}
                                                    </td>
                                                    {
                                                        index == 0 &&
                                                        <td align="right" rowSpan={this.state.rowstt.length}>
                                                            {totnilaitt}
                                                        </td>
                                                    }
                                                </tr>
                                            );
                                        })

                                    : 
                                    <tr>
                                        <td colSpan="17" className="text-center">Tidak Ada Data Menunggu Approval</td>
                                    </tr>
                                }
                                <tr>
                                    <td colSpan={17} rowSpan={2} align="center">Nilai Capaian SKP</td>
                                    <td align="right">
                                        {/* {totnilaiskp=totnilaiskp+totnilaitt} */}
                                        <AvField
                                            name="nilaiakhir"
                                            type="hidden"
                                            value={totnilaiskp=totnilaiskp+totnilaitt}
                                        />
                                        <AvField
                                            name="capaian_total"
                                            type="hidden"
                                            value={((totnilaiskp/this.state.rows.length)*60/100) ?? ''}
                                        />
                                        <AvField
                                            name="average_skp"
                                            type="hidden"
                                            value={(totnilaiskp/this.state.rows.length) ?? ''}
                                        />
                                        {
                                          (totnilaiskp/this.state.rows.length)  
                                        }
                                    </td>
                                </tr>
                                <tr>
                                    <td align="center">
                                        {
                                            (() => {
                                                if(totnilaiskp<50){
                                                    return "Buruk";
                                                }
                                                if(totnilaiskp<60){
                                                    return "Sedang";
                                                }
                                                if(totnilaiskp<75){
                                                    return "Cukup";
                                                }
                                                if(totnilaiskp<90){
                                                    return "Baik";
                                                }
                                                if(totnilaiskp<99){
                                                    return "Sangat Baik";
                                                }
                                              })()
                                        }
                                    </td>
                                </tr>
                            </tbody>
                        </Table>
                    </div>
                    {
                        (this.state.rows[0]?.skp_status==7)?
                        <Row className="mb-3">
                        <Col md="9">
                            <Button color="success" type="submit" disabled={this.state.totalRow > 0 ? false : true}>
                                <i className="uil-arrow-up-right"></i> Approve Pengukuran SKP
                            </Button>
                        </Col>
                    </Row>
                    :''
                    }

                </AvForm>


                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin akan menyimpan data ini?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil disimpan"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal disimpan"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                { this.state.detailUuid !== null ?
                    // <Redirect to={"/sample.html?detail&uuid=" + this.state.detailUuid}/>
                    <Redirect to={"/kepegawaian/skp.html?input_realisasi&uuid=" + this.state.detailUuid}/>
                : null }
            </>
        )
    }

}

export default TableActivePengukuranComponent